import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { DropletsIcon, TargetIcon, ShieldIcon, CalendarCheckIcon } from 'lucide-react';
export function HowToUseSection() {
  return <Section background="white" data-id="element-67">
      <div className="text-center mb-14" data-id="element-68">
        <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-4" data-id="element-69">
          Cómo se usa{' '}
          <span className="text-[#C4A962] italic" data-id="element-70">(sin abrumarte)</span>
        </h2>
      </div>

      <div className="relative max-w-xl mx-auto" data-id="element-71">
        {/* Vertical timeline line */}
        <div className="absolute left-6 top-4 bottom-4 w-px bg-[#E8EDE6] hidden md:block" data-id="element-72" />

        {/* Step 1 */}
        <motion.div initial={{
        opacity: 0,
        x: -12
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0,
        duration: 0.5
      }} className="flex gap-5 mb-10 relative" data-id="element-73">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-red-50 border-2 border-red-200 flex items-center justify-center z-10" data-id="element-74">
            <DropletsIcon size={20} className="text-red-700" data-id="element-75" />
          </div>
          <div className="pt-1" data-id="element-76">
            <span className="text-xs font-bold uppercase tracking-wider text-[#C4A962]" data-id="element-77">
              Día 1
            </span>
            <h3 className="text-lg font-bold text-[#2D3B2D] mt-1" data-id="element-78">
              Mapa Sangrado
            </h3>
            <p className="text-[#4A5D4A] text-sm mt-1 leading-relaxed" data-id="element-79">
              Detectas fugas y gastos fantasma.{' '}
              <span className="text-[#2D3B2D] font-medium" data-id="element-80">10–15 min.</span>
            </p>
          </div>
        </motion.div>

        {/* Step 2 */}
        <motion.div initial={{
        opacity: 0,
        x: -12
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1,
        duration: 0.5
      }} className="flex gap-5 mb-10 relative" data-id="element-81">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-emerald-50 border-2 border-emerald-200 flex items-center justify-center z-10" data-id="element-82">
            <TargetIcon size={20} className="text-emerald-700" data-id="element-83" />
          </div>
          <div className="pt-1" data-id="element-84">
            <span className="text-xs font-bold uppercase tracking-wider text-[#C4A962]" data-id="element-85">
              Día 2
            </span>
            <h3 className="text-lg font-bold text-[#2D3B2D] mt-1" data-id="element-86">
              Mapa Ataque
            </h3>
            <p className="text-[#4A5D4A] text-sm mt-1 leading-relaxed" data-id="element-87">
              Ordenas deudas y defines qué pagar primero.{' '}
              <span className="text-[#2D3B2D] font-medium" data-id="element-88">15–20 min.</span>
            </p>
          </div>
        </motion.div>

        {/* Step 3 */}
        <motion.div initial={{
        opacity: 0,
        x: -12
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="flex gap-5 mb-10 relative" data-id="element-89">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-amber-50 border-2 border-amber-200 flex items-center justify-center z-10" data-id="element-90">
            <ShieldIcon size={20} className="text-amber-700" data-id="element-91" />
          </div>
          <div className="pt-1" data-id="element-92">
            <span className="text-xs font-bold uppercase tracking-wider text-[#C4A962]" data-id="element-93">
              Día 3
            </span>
            <h3 className="text-lg font-bold text-[#2D3B2D] mt-1" data-id="element-94">
              Mapa Protección
            </h3>
            <p className="text-[#4A5D4A] text-sm mt-1 leading-relaxed" data-id="element-95">
              Creas tu mini fondo anti-imprevistos.{' '}
              <span className="text-[#2D3B2D] font-medium" data-id="element-96">10 min.</span>
            </p>
          </div>
        </motion.div>

        {/* Step 4 */}
        <motion.div initial={{
        opacity: 0,
        x: -12
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="flex gap-5 relative" data-id="element-97">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#FDF8F0] border-2 border-[#E8EDE6] flex items-center justify-center z-10" data-id="element-98">
            <CalendarCheckIcon size={20} className="text-[#2D3B2D]" data-id="element-99" />
          </div>
          <div className="pt-1" data-id="element-100">
            <span className="text-xs font-bold uppercase tracking-wider text-[#C4A962]" data-id="element-101">
              Semana 1–4
            </span>
            <h3 className="text-lg font-bold text-[#2D3B2D] mt-1" data-id="element-102">
              1 acción por semana + seguimiento simple
            </h3>
            <p className="text-[#4A5D4A] text-sm mt-1 leading-relaxed" data-id="element-103">
              Sin listas interminables. Una cosa a la vez.
            </p>
          </div>
        </motion.div>
      </div>

      <motion.p initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.5
    }} className="text-center mt-14 text-lg font-medium text-[#2D3B2D] italic" data-id="element-104">
        No necesitas hacerlo perfecto. Solo hacerlo simple.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.6
    }} className="mt-6 mx-auto max-w-md bg-[#FDF8F0] border border-[#E8EDE6] rounded-xl px-6 py-4 text-center" data-id="element-105">
        <p className="text-sm text-[#2D3B2D] leading-relaxed" data-id="element-106">
          <span className="font-semibold" data-id="element-107">Si hoy solo haces una cosa:</span>{' '}
          abre el Mapa 1 (Sangrado) y marca 3 fugas. Eso ya es progreso.
        </p>
      </motion.div>
    </Section>;
}